/**
 * Expert data utilities.
 *
 * The canonical expert list lives in the backend (services/experts_service.py)
 * and is fetched via GET /api/user/experts (see src/utils/api.js fetchExperts).
 *
 * This module provides a pure helper to resolve an expert name from a fetched list.
 */

/**
 * Returns the display name for an expert_id, looked up from a fetched experts array.
 * Falls back to the raw id if not found.
 *
 * @param {string} id - expert_id (e.g. 'expert-1')
 * @param {Array} experts - array returned by fetchExperts()
 * @returns {string|null}
 */
export const getExpertNameById = (id, experts = []) => {
  const key = String(id ?? '').trim();
  if (!key) return null;
  const match = experts.find((e) => e.id === key);
  return match?.name ?? null;
};

/**
 * Returns the calendar_url for an expert_id from a fetched experts array.
 *
 * @param {string} id - expert_id (e.g. 'expert-1')
 * @param {Array} experts - array returned by fetchExperts()
 * @returns {string|null}
 */
export const getExpertCalendarUrlById = (id, experts = []) => {
  const key = String(id ?? '').trim();
  if (!key) return null;
  const match = experts.find((e) => e.id === key);
  const url = String(match?.calendar_url ?? '').trim();
  return url || null;
};
